import React, { useState } from "react";
import LandingTableBotton from "../../../../Resusable/LandingTableBotton";
import AllPublicTable from "../tables/AllPublicTable";
import TodayPublicTable from "../tables/TodayPublicTable";
import UpcommingPublicTable from "../tables/UpcommingPublicTable";
import { Select } from "react-materialize";
import { useMediaQuery } from "react-responsive";

function LandingTableArea({ homeRef }) {
  const isTablet = useMediaQuery({ query: "(max-width: 700px)" });
  const [buttonPosition, setButtonPosition] = useState(1);
  const [auctionFilter, setAuctionFilter] = useState("");
  return (
    <div
      className="cover z-depth-1"
      style={{ padding: "25px 35px", marginTop: "1.5rem" }}
      ref={homeRef}
    >
      <div className="valign-wrapper space-between flex-wrap">
        <LandingTableBotton
          buttonPosition={buttonPosition}
          setButtonPosition={setButtonPosition}
        />
        <span
          className="input-field-style"
          style={{
            height: "40px",
            width: isTablet ? "90%" : "200px",
            margin: isTablet && "auto"
          }}
        >
          <img src="/images/urlIcon.png" alt="auctionLogo" width={25} />
          <Select
            className="custom-width-dropdown"
            multiple={false}
            options={{
              classes: "browser-default",
              dropdownOptions: {
                alignment: "left",
                autoTrigger: true,
                closeOnClick: true,
                constrainWidth: true,
                coverTrigger: false,
              },
            }}
            onChange={(e) => setAuctionFilter(e.target.value)}
          >
            <option value="">All Auction</option>
            <option value="forwardAuction">Forward Auction</option>
            <option value="reverseAuction">Reverse Auction</option>
          </Select>
        </span>
      </div>
      <div className="mt-1">
        {buttonPosition === 1 && <AllPublicTable auctionFilter={auctionFilter} />}
        {buttonPosition === 2 && <TodayPublicTable auctionFilter={auctionFilter} />}
        {buttonPosition === 3 && <UpcommingPublicTable auctionFilter={auctionFilter} />}
      </div>
    </div>
  );
}

export default LandingTableArea;
